(function () {
  function moveTabs() {
    var area = document.querySelector('.s-accordion-desc-area');
    if (!area || area.closest('.ss-tabs-band')) return;
    var main = area.closest('.shopify-section');
    if (!main) return;

    var band = document.createElement('div');
    band.className = 'ss-tabs-band';
    var inner = document.createElement('div');
    inner.className = 'ss-tabs-band__inner';
    band.appendChild(inner);

    var ref = main;
    var next = main.nextElementSibling;
    if (next && /ss_product_bundle/.test(next.id) && next.offsetHeight > 0) ref = next;
    ref.parentNode.insertBefore(band, ref.nextSibling);
    inner.appendChild(area);

    var panels = area.querySelectorAll('details');
    if (panels.length < 2) {
      band.classList.add('ss-single');
      if (panels[0]) {
        panels[0].open = true;
        var summary = panels[0].querySelector('summary');
        var label = summary ? summary.textContent.replace(/\s+/g, ' ').trim() : 'Description';
        var nav = document.createElement('div');
        nav.className = 'ss-tabs__nav';
        var tab = document.createElement('span');
        tab.className = 'ss-tabs__btn';
        tab.setAttribute('aria-selected', 'true');
        tab.textContent = label;
        nav.appendChild(tab);
        area.insertBefore(nav, area.firstChild);
      }
    }
  }

  /* Breadcrumbs sit centered above the image and title so both columns start on the same line */
  function moveCrumbs() {
    var crumbs = document.querySelector('.product__media-wrapper .breadcrumbs_area');
    if (!crumbs) return;
    var grid = crumbs.closest('.product');
    if (!grid || !grid.parentNode) return;
    crumbs.classList.add('ss-crumbs');
    grid.parentNode.insertBefore(crumbs, grid);
  }

  function syncStock() {
    var btn = document.querySelector('.product-form__submit');
    var box = document.querySelector('.product__back-in-stock');
    if (!btn) return;
    var soon = /^\s*Coming Back Soon/i.test(btn.textContent);
    if (soon && btn.textContent.trim() !== 'Coming Back Soon') btn.textContent = 'Coming Back Soon';
    if (box) {
      box.classList.toggle('ss-notify', soon);
      var link = box.querySelector('.BIS_trigger');
      if (soon && link) {
        link.style.removeProperty('display');
        if (link.textContent.trim() !== 'Notify Me When In Stock') link.textContent = 'Notify Me When In Stock';
      }
    }
  }

  var imageMap = null;
  var imageRequest = null;

  function loadImages() {
    if (imageRequest) return imageRequest;
    var path = location.pathname.replace(/\/$/, '') + '.js';
    imageRequest = fetch(path)
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var names = (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
        imageMap = {};
        names.forEach(function (name, idx) {
          if (!/colou?r/i.test(name)) return;
          var map = {};
          product.variants.forEach(function (v) {
            var val = v['option' + (idx + 1)];
            var img = v.featured_image && v.featured_image.src;
            if (val && img && !map[val]) map[val] = img;
          });
          imageMap[name.toLowerCase()] = map;
        });
      })
      .catch(function () { imageMap = {}; });
    return imageRequest;
  }

  function thumb(src) {
    return src.replace(/(\.\w+)(\?|$)/, '_80x80$1$2');
  }

  function buildDropdown(fs) {
    var radios = fs.querySelectorAll('input[type=radio]');
    if (radios.length < 6 || fs.querySelector('.ss-dd__panel')) return;
    var legend = fs.querySelector('legend');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ss-dd__btn';
    btn.setAttribute('aria-haspopup', 'true');
    btn.setAttribute('aria-expanded', 'false');
    var panel = document.createElement('div');
    panel.className = 'ss-dd__panel';
    Array.prototype.slice.call(fs.children).forEach(function (child) {
      if (child !== legend) panel.appendChild(child);
    });
    fs.classList.add('ss-dd');
    fs.appendChild(btn);
    fs.appendChild(panel);
    btn.addEventListener('click', function () {
      var open = fs.classList.toggle('ss-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function syncDropdown(fs) {
    var btn = fs.querySelector('.ss-dd__btn');
    if (!btn) return;
    var checked = fs.querySelector('input:checked');
    var label = checked && checked.nextElementSibling;
    var img = label && label.querySelector('.ss-vimg');
    var value = checked ? checked.value : 'Select';
    var src = img ? img.getAttribute('src') : '';
    var key = value + '|' + src;
    if (btn.getAttribute('data-key') === key) return;
    btn.setAttribute('data-key', key);
    btn.textContent = '';
    if (src) {
      var pic = document.createElement('img');
      pic.className = 'ss-vimg';
      pic.alt = '';
      pic.src = src;
      btn.appendChild(pic);
    }
    var text = document.createElement('span');
    text.className = 'ss-dd__txt';
    text.textContent = value;
    btn.appendChild(text);
    var chev = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    chev.setAttribute('class', 'ss-dd__chev');
    chev.setAttribute('viewBox', '0 0 12 8');
    chev.setAttribute('fill', 'none');
    chev.setAttribute('stroke', 'currentColor');
    chev.setAttribute('stroke-width', '2');
    chev.setAttribute('stroke-linecap', 'round');
    chev.setAttribute('stroke-linejoin', 'round');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M1 1.5l5 5 5-5');
    chev.appendChild(path);
    btn.appendChild(chev);
  }

  function addImages(sets) {
    Array.prototype.forEach.call(sets, function (fs) {
      var legend = fs.querySelector('legend');
      var name = legend ? legend.childNodes[0].textContent.trim().toLowerCase() : '';
      var map = imageMap && imageMap[name];
      if (!map) return;
      Array.prototype.forEach.call(fs.querySelectorAll('input[type=radio]'), function (input) {
        var label = input.nextElementSibling;
        var src = map[input.value];
        if (!label || !src || label.querySelector('.ss-vimg')) return;
        var img = document.createElement('img');
        img.className = 'ss-vimg';
        img.alt = '';
        img.src = thumb(src);
        label.insertBefore(img, label.firstChild);
      });
      syncDropdown(fs);
    });
  }

  function decorate() {
    syncStock();
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var sets = vs.querySelectorAll('fieldset');
    Array.prototype.forEach.call(sets, function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend) return;
      var out = legend.querySelector('.ss-vsel');
      if (!out) {
        out = document.createElement('span');
        out.className = 'ss-vsel';
        legend.appendChild(out);
      }
      var checked = fs.querySelector('input:checked');
      var text = checked ? ': ' + checked.value : '';
      if (out.textContent !== text) out.textContent = text;
      if (imageMap) addImages([fs]);
      buildDropdown(fs);
      if (imageMap) addImages([fs]);
      syncDropdown(fs);
    });

    if (!imageMap) {
      loadImages().then(function () {
        addImages(vs.querySelectorAll('fieldset'));
      });
    }
  }

  /* The Write a review link under the title jumps to the review form and opens it */
  function openReviewForm(trigger) {
    var widget = document.querySelector('.jdgm-review-widget, .jdgm-rev-widg');
    if (!widget) return false;
    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var btn = widget.querySelector('.jdgm-write-rev-link, .jdgm-write-rev-link-new');
    if (btn && btn !== trigger) {
      setTimeout(function () { btn.click(); }, 450);
    }
    return true;
  }

  function init() {
    moveTabs();
    moveCrumbs();
    decorate();
    setTimeout(syncStock, 400);
    setTimeout(syncStock, 1000);
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var link = e.target.closest('.jdgm-write-rev-link, .jdgm-write-rev-link-new');
      if (!link || link.closest('.jdgm-review-widget, .jdgm-rev-widg')) return;
      if (openReviewForm(link)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
    document.addEventListener('change', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('variant-selects')) {
        var fs = e.target.closest('fieldset.ss-dd');
        if (fs) fs.classList.remove('ss-open');
      }
    });
    document.addEventListener('click', function (e) {
      Array.prototype.forEach.call(document.querySelectorAll('fieldset.ss-dd.ss-open'), function (fs) {
        if (!fs.contains(e.target)) fs.classList.remove('ss-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      Array.prototype.forEach.call(document.querySelectorAll('fieldset.ss-dd.ss-open'), function (fs) {
        fs.classList.remove('ss-open');
      });
      var modal = document.querySelector('.ss-modal-overlay.ss-modal--open');
      if (modal) modal.classList.remove('ss-modal--open');
    });

    /* Re-decorate in the same frame the theme swaps the product info, so nothing flashes undecorated */
    var holder = document.querySelector('.product__info-container');
    if (holder && window.MutationObserver) {
      var watch = {childList: true, subtree: true, characterData: true};
      var observer = new MutationObserver(function () {
        observer.disconnect();
        decorate();
        observer.takeRecords();
        observer.observe(holder, watch);
      });
      observer.observe(holder, watch);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
